import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const items = [
  {
    title: "Stand Out",
    desc: "New members walk in excited but quickly feel overwhelmed. They don’t know how to structure a workout or use the machines, give up before seeing results, and never form lasting habits.",
  },
  { title: "Build Confidence", desc: "New members often quit early because they don’t know what to do. With FlxDeck, they always have a plan that fits their goals, time, and experience." },
  { title: "Grow Coaching Revenue", desc: "After members get a taste of custom workouts and see results, FlxDeck guides them toward personal training and delivers leads straight to your inbox." },
  { title: "Train Safely", desc: "Step-by-step guidance with GIFs ensures proper form, reduces risk, and improves equipment wear and tear." },
];

const WhyFlxDeck = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.whyFlxDeck : jsonDataFr.data.whyFlxDeck;

  return (
    <section className="why">
      {/* Background Video */}
      <video className="why__video" autoPlay muted loop playsInline>
        <source src="assets/home/gym-bg-720.mp4" type="video/mp4" />
        <source src="assets/home/gym-bg-480.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="why__overlay"></div>

      <div className="why__inner">
        <h2 className="why__title">{data.title}</h2>
        <p className="why__desc">{data.description}</p>

        <div className="why__grid">
          {Object.values(data.cards).map(({ title, description }) => (
            <article key={title} className="why-card">
              <h3 className="why-card__title">{title}</h3>
              <p className="why-card__desc">{description}</p>
            </article>
          ))}
        </div>

        <a href="#contact" className="why__cta">
          {data.btn}
        </a>
      </div>
    </section>
  );
};

export default WhyFlxDeck;
